import { gql, useMutation } from '@apollo/client'
export const USER_SENTENCES_QUERY = gql`
  query AllUserSentencesWithTranslations($username: String!, $lang: String!, $relationships: [String!]!) {
    allUserSentencesWithTranslations(username: $username, lang: $lang, relationships: $relationships) {
      sentence {
        id
        text
        lang
      }
      translations {
        id
        text
        lang
      }
    }
  }
`

export const ADD_USER_SENTENCE_MUTATION = gql`
  mutation AddUserSentence(
    $sourceText: String!
    $targetText: String!
    $sourceLang: String!
    $targetLang: String!
    $tags: [String]!
    $username: String!
    $sharedWith: [String]!
  ) {
    AddUserSentence(
      sourceText: $sourceText
      targetText: $targetText
      sourceLang: $sourceLang
      targetLang: $targetLang
      tags: $tags
      username: $username
      sharedWith: $sharedWith
    ) {
      sentence {
        id
        text
        lang
      }
      translations {
        id
        text
        lang
      }
    }
  }
`

export const USER_SENTENCES_WITH_TRANSLATIONS_QUERY = gql`
  query UserSentencesWithTranslations($username: String!, $lang: String!, $translationLang: String!) {
    userSentencesWithTranslations(username: $username, lang: $lang, translationLang: $translationLang) {
      sentence {
        id
        text
        lang
      }
      translations {
        id
        text
        lang
      }
    }
  }
`
export const SHARED_SENTENCES_WITH_TRANSLATIONS_QUERY = gql`
  query SharedSentencesWithTranslations($username: String!, $lang: String!, $translationLang: String!) {
    sharedSentencesWithTranslations(username: $username, lang: $lang, translationLang: $translationLang) {
      sentence {
        id
        text
        lang
      }
      translations {
        id
        text
        lang
      }
    }
  }
`;
export const TATOEBA_SENTENCES_QUERY = gql`
  query SentenceWithTranslations($lang: String!, $word: String!, $translationLang: String!) {
    SentenceWithTranslations(lang: $lang, word: $word, translationLang: $translationLang) {
      sentence {
        id
        text
        lang
      }
      translations {
        id
        text
        lang
      }
    }
  }
`
export const GET_ALL_TRANSLATION_USER_SENTENCES = gql`
  query AllTranslationUserSentences($username: String!, $sourceLang: String) {
    allTranslationUserSentences(username: $username, sourceLang: $sourceLang) {
      sentence {
        id
        text
        lang
        user
        dateAdded
        dateLastModified
      }
      translations {
        id
        text
        lang
        user
        dateAdded
        dateLastModified
      }
    }
  }
`
export const FLASHCARD_SENTENCES_QUERY = gql`
  query FlashcardSentences($username: String!, $sourceLang: String, $targetLang: String, $tags: [String]) {
    flashcardSentences(username: $username, sourceLang: $sourceLang, targetLang: $targetLang, tags: $tags) {
      sentence {
        id
        text
        lang
        user
        dateAdded
        dateLastModified
        imageUrl
        imageDescription
      }
      translations {
        id
        text
        lang
        user
        dateAdded
        dateLastModified
        imageUrl
        imageDescription
      }
    }
  }
`

// Record a mnemonic-image URL for a Word, keyed by (text, lang, username).
// Bytes are NOT sent through GraphQL — the frontend uploads to the image
// server first and only passes the resulting public URL here. This keeps the
// Render-hosted GraphQL server free of byte storage (its disk is ephemeral).
export const SET_WORD_IMAGE_MUTATION = gql`
  mutation SetWordImage($text: String!, $lang: String!, $username: String!, $imageUrl: String!, $description: String) {
    setWordImage(text: $text, lang: $lang, username: $username, imageUrl: $imageUrl, description: $description) {
      id
      text
      lang
      imageUrl
      imageDescription
      imageGeneratedAt
    }
  }
`

export const REMOVE_WORD_IMAGE_MUTATION = gql`
  mutation RemoveWordImage($text: String!, $lang: String!, $username: String!) {
    removeWordImage(text: $text, lang: $lang, username: $username) {
      id
      text
      lang
      imageUrl
    }
  }
`
export const GET_ALL_TRANSLATION_SHARED_SENTENCES = gql`
  query AllSharedSentencesWithTranslations($username: String!, $sourceLang: String) {
    allSharedSentencesWithTranslations(username: $username, sourceLang: $sourceLang) {
      sentence {
        id
        text
        lang
        user
        dateAdded
        dateLastModified
      }
      translations {
        id
        text
        lang
        user
        dateAdded
        dateLastModified
      }
    }
  }
`
export const TATOEBA_SENTENCES_ALL_TRANSLATIONS_QUERY = gql`
  query SentenceWithAllTranslations($lang: String!, $word: String!) {
    SentenceWithAllTranslations(lang: $lang, word: $word) {
      sentence {
        id
        text
        lang
      }
      translations {
        id
        text
        lang
      }
    }
  }
`
export const GET_INSPIRATIONS_QUERY = gql`
  query GetInspirations($username: String!) {
    getInspirations(username: $username) {
      identity
      labels
      properties {
        text
        lang
        username
      }
      elementId
    }
  }
`
export const SAVE_SENTENCE_MUTATION = gql`
  mutation SaveSentence($username: String!, $sentenceId: ID!) {
    SaveSentence(username: $username, sentenceId: $sentenceId) {
      id
      text
      lang
    }
  }
`
export const CHECK_SAVED_STATUS_QUERY = gql`
  query CheckSavedStatus($username: String!, $sourceSentenceId: ID!, $translationSentenceId: ID!) {
    checkSavedStatus(username: $username, sourceSentenceId: $sourceSentenceId, translationSentenceId: $translationSentenceId) {
      sourceSaved
      translationSaved
    }
  }
`
export const SAVE_SENTENCES_MUTATION = gql`
  mutation SaveSentences($username: String!, $sourceSentenceId: ID!, $translationSentenceId: ID!) {
    saveSentences(username: $username, sourceSentenceId: $sourceSentenceId, translationSentenceId: $translationSentenceId) {
      sourceSentence {
        id
      }
      sourceSaved
      translationSentence {
        id
      }
      translationSaved
    }
  }
`
export const LOGIN_MUTATION = gql`
  mutation Login($username: String!, $password: String!) {
    login(username: $username, password: $password) {
      token
      user {
        id
        username
      }
    }
  }
`;
export const REGISTER_MUTATION = gql`
  mutation Register($username: String!, $password: String!) {
    register(username: $username, password: $password) {
      id
      username
    }
  }
`;
export const GET_PROJECTS_QUERY = gql`
  query GetProjects($username: String!) {
    getProjects(username: $username) {
      identity
      labels
      properties {
        title
        username
      }
      elementId
    }
  }
`;
export const GET_TASKS_BY_PROJECT_QUERY = gql`
  query GetTasksByProject($projectName: String!) {
    getTasksByProject(projectName: $projectName) {
      task {
        identity
        labels
        properties {
          title
          type
          description
          priority
          assignee
          timeBudget
          timeSpent
          dueDate
          dateAdded
          dateLastModified
          username
          project
        }
        elementId
        assignedTo {
          identity
          properties {
            username
          }
        }
      }
      status
    }
  }
`;
export const GET_TASKS_QUERY = gql`
query GetTasks($username: String!) {
  getTasks(username: $username) {
    identity
    status
    properties {
      title
      type
      description
      priority
      timeBudget
      timeSpent
      project
      assignee
      dueDate
    }
    elementId
  }
}
`;
export const UPDATE_TASK_MUTATION = gql`
  mutation UpdateTask($identity: ID!, $input: TaskUpdateInput!) {
    updateTask(identity: $identity, input: $input) {
      identity
      properties {
        timeSpent
      }
    }
  }
`;
export const DELETE_TASK_MUTATION = gql`
  mutation DeleteTask($identity: ID!) {
    deleteTask(identity: $identity)
  }
`;
export const ADD_NOTE_MUTATION = gql`
  mutation AddNote(
    $title: String!
    $mapData: String!
    $linkedProject: String
    $linkedTaskId: String
    $username: String!
  ) {
    addNote(input: {
      title: $title
      mapData: $mapData
      linkedProject: $linkedProject
      linkedTaskId: $linkedTaskId
      username: $username
    }) {
      identity
      elementId
      properties {
        title
        mapData
        linkedProject
        username
        dateAdded
      }
    }
  }
`;
export const GET_NOTES_QUERY = gql`
  query GetNotes($username: String!, $linkedProject: String, $linkedTaskId: String) {
    getNotes(username: $username, linkedProject: $linkedProject, linkedTaskId: $linkedTaskId) {
      identity
      elementId
      properties {
        title
        mapData
        linkedProject
        username
        dateAdded
        dateLastModified
      }
    }
  }
`;

export const ADD_MEETING_WITH_CONTENT_MUTATION = gql`
  mutation AddMeetingWithContent($input: AddMeetingWithContentInput!) {
    addMeetingWithContent(input: $input) {
      meeting {
        identity
        properties {
          title
          type
        }
      }
      sentenceCount
      wordCount
      taskCount
    }
  }
`;

export const DELETE_MEETING_MUTATION = gql`
  mutation DeleteMeeting($identity: ID!) {
    deleteMeeting(identity: $identity)
  }
`;

export const ADD_MEETING_SENTENCE_MUTATION = gql`
  mutation AddMeetingSentence($input: AddMeetingSentenceInput!) {
    addMeetingSentence(input: $input) {
      source { id text lang }
      target { id text lang }
    }
  }
`;

export const ADD_MEETING_WORD_MUTATION = gql`
  mutation AddMeetingWord($input: AddMeetingWordInput!) {
    addMeetingWord(input: $input) {
      source { id text lang imageUrl imageDescription }
      target { id text lang }
    }
  }
`;

export const DELETE_MEETING_SENTENCE_MUTATION = gql`
  mutation DeleteMeetingSentence($sentenceId: ID!) {
    deleteMeetingSentence(sentenceId: $sentenceId)
  }
`;

export const DELETE_MEETING_WORD_MUTATION = gql`
  mutation DeleteMeetingWord($meetingId: ID!, $wordId: ID!) {
    deleteMeetingWord(meetingId: $meetingId, wordId: $wordId)
  }
`;

export const UPDATE_MEETING_DATE_MUTATION = gql`
  mutation UpdateMeetingDate($identity: ID!, $meetingDate: String!) {
    updateMeetingDate(identity: $identity, meetingDate: $meetingDate) {
      identity
      properties {
        title
        type
        meetingDate
        dateAdded
        dateLastModified
      }
    }
  }
`;

export const GET_MEETINGS_QUERY = gql`
  query GetMeetings($username: String!) {
    getMeetings(username: $username) {
      identity
      labels
      properties {
        title
        type
        description
        username
        meetingDate
        dateAdded
        dateLastModified
      }
      elementId
    }
  }
`;

export const RECORD_PRACTICE_MUTATION = gql`
  mutation RecordPractice($username: String!, $itemId: ID!, $itemType: String!, $isCorrect: Boolean!) {
    recordPractice(username: $username, itemId: $itemId, itemType: $itemType, isCorrect: $isCorrect) {
      timesPracticed
      timesCorrect
      lastPracticedAt
      nextReviewAt
      interval
    }
  }
`

export const GET_MEETING_WITH_CONTENT_QUERY = gql`
  query GetMeetingWithContent($identity: ID!) {
    getMeetingWithContent(identity: $identity) {
      meeting {
        identity
        labels
        properties {
          title
          type
          description
          username
          meetingDate
          dateAdded
          dateLastModified
        }
        elementId
      }
      sentences {
        source {
          id
          text
          lang
        }
        target {
          id
          text
          lang
        }
      }
      words {
        source {
          id
          text
          lang
          imageUrl
          imageDescription
        }
        target {
          id
          text
          lang
        }
      }
      tasks {
        id
        title
        type
        description
        priority
      }
    }
  }
`;

export const ADD_PARAGRAPH_WITH_CONTENT_MUTATION = gql`
  mutation AddParagraphWithContent($input: AddParagraphWithContentInput!) {
    addParagraphWithContent(input: $input) {
      paragraph {
        identity
        properties {
          title
          text
          lang
          posMap
        }
      }
      sentenceCount
      wordCount
    }
  }
`;

export const GET_PARAGRAPHS_QUERY = gql`
  query GetParagraphs($username: String!, $lang: String) {
    getParagraphs(username: $username, lang: $lang) {
      identity
      labels
      properties {
        title
        text
        lang
        posMap
        username
        dateAdded
        dateLastModified
      }
      elementId
    }
  }
`;

export const GET_PARAGRAPH_WITH_CONTENT_QUERY = gql`
  query GetParagraphWithContent($identity: ID!, $username: String) {
    getParagraphWithContent(identity: $identity, username: $username) {
      paragraph {
        identity
        labels
        properties {
          title
          text
          lang
          posMap
          username
          dateAdded
          dateLastModified
        }
        elementId
      }
      sentences {
        source {
          id
          text
          lang
          order
        }
        target {
          id
          text
          lang
        }
      }
      words {
        source {
          id
          text
          lang
          timesPracticed
          timesCorrect
          lastPracticedAt
          imageUrl
          imageDescription
        }
        target {
          id
          text
          lang
        }
      }
    }
  }
`;

export const DELETE_PARAGRAPH_MUTATION = gql`
  mutation DeleteParagraph($identity: ID!) {
    deleteParagraph(identity: $identity)
  }
`;

export const ADD_PARAGRAPH_WORD_LOOKUP_MUTATION = gql`
  mutation AddParagraphWordLookup(
    $username: String!
    $paragraphId: ID!
    $word: String!
    $translation: String!
    $lang: String!
  ) {
    addParagraphWordLookup(
      username: $username
      paragraphId: $paragraphId
      word: $word
      translation: $translation
      lang: $lang
    ) {
      id
      text
      lang
    }
  }
`;
// ─── Media ────────────────────────────────────────────────────────────
// Persistent project store for the media workflow. The Mac mini owns
// the filesystem; this module owns the Neo4j metadata + check-out registry.

export const LIST_MEDIA_COLLECTIONS_QUERY = gql`
  query ListMediaCollections($username: String, $project: String) {
    listMediaCollections(username: $username, project: $project) {
      identity
      properties {
        name
        slug
        project
        projectSlug
        notes
        shootDate
        basePath
        username
        createdAt
        dateLastModified
        checkedOutBy
        checkedOutAt
      }
    }
  }
`;

export const GET_MEDIA_COLLECTION_QUERY = gql`
  query GetMediaCollection($identity: ID!) {
    getMediaCollection(identity: $identity) {
      project {
        identity
        properties {
          name
          slug
          project
          projectSlug
          notes
          shootDate
          basePath
          username
          createdAt
          dateLastModified
          checkedOutBy
          checkedOutAt
        }
      }
      folders {
        name
        path
        fileCount
        totalBytes
        lastModified
      }
    }
  }
`;

export const CREATE_MEDIA_COLLECTION_MUTATION = gql`
  mutation CreateMediaCollection($input: CreateMediaCollectionInput!) {
    createMediaCollection(input: $input) {
      identity
      properties {
        name
        slug
        basePath
        createdAt
        shootDate
      }
    }
  }
`;

export const UPDATE_MEDIA_COLLECTION_DATE_MUTATION = gql`
  mutation UpdateMediaCollectionDate($identity: ID!, $shootDate: String!) {
    updateMediaCollectionDate(identity: $identity, shootDate: $shootDate) {
      identity
      properties {
        shootDate
        dateLastModified
      }
    }
  }
`;

export const CHECK_OUT_MEDIA_COLLECTION_MUTATION = gql`
  mutation CheckOutMediaCollection($identity: ID!, $username: String!) {
    checkOutMediaCollection(identity: $identity, username: $username) {
      identity
      properties {
        checkedOutBy
        checkedOutAt
      }
    }
  }
`;

export const CHECK_IN_MEDIA_COLLECTION_MUTATION = gql`
  mutation CheckInMediaCollection($identity: ID!) {
    checkInMediaCollection(identity: $identity) {
      identity
      properties {
        checkedOutBy
        checkedOutAt
      }
    }
  }
`;

export const DELETE_MEDIA_COLLECTION_MUTATION = gql`
  mutation DeleteMediaCollection($identity: ID!) {
    deleteMediaCollection(identity: $identity)
  }
`;

export const BROWSE_MEDIA_FOLDER_QUERY = gql`
  query BrowseMediaFolder($projectIdentity: ID!, $path: String) {
    browseMediaFolder(projectIdentity: $projectIdentity, path: $path) {
      path
      folders {
        name
        path
        fileCount
        totalBytes
        lastModified
      }
      photos {
        identity
        projectIdentity
        folder
        filename
        size
        mtime
        thumbnailUrl
      }
    }
  }
`;

export const GET_MEDIA_LIBRARY_QUERY = gql`
  query GetMediaLibrary($username: String!) {
    getMediaLibrary(username: $username) {
      date
      devices {
        device
        assets {
          identity
          path
          filename
          date
          device
          kind
          size
          mtime
          thumbnailUrl
          projects
        }
      }
    }
  }
`;

export const ATTACH_MEDIA_ASSETS_MUTATION = gql`
  mutation AttachMediaAssets($paths: [String!]!, $project: String!, $username: String!) {
    attachMediaAssetsToProject(paths: $paths, project: $project, username: $username)
  }
`;

export const ATTACH_TASK_OUTPUTS_MUTATION = gql`
  mutation AttachTaskOutputs($taskId: ID!, $paths: [String!]!, $username: String!) {
    attachTaskOutputs(taskId: $taskId, paths: $paths, username: $username)
  }
`;

export const DETACH_TASK_OUTPUT_MUTATION = gql`
  mutation DetachTaskOutput($taskId: ID!, $path: String!) {
    detachTaskOutput(taskId: $taskId, path: $path)
  }
`;

export const GET_TASK_OUTPUTS_QUERY = gql`
  query GetTaskOutputs($taskId: ID!) {
    getTaskOutputs(taskId: $taskId) {
      identity
      path
      filename
      kind
      thumbnailUrl
    }
  }
`;

export const GET_TASKS_FOR_MEDIA_PATHS_QUERY = gql`
  query GetTasksForMediaPaths($paths: [String!]!) {
    getTasksForMediaPaths(paths: $paths) {
      path
      tasks { id title }
    }
  }
`;

export const DETACH_MEDIA_ASSET_MUTATION = gql`
  mutation DetachMediaAsset($path: String!, $project: String!) {
    detachMediaAssetFromProject(path: $path, project: $project)
  }
`;

export const LIST_PROJECT_PHOTOS_QUERY = gql`
  query ListProjectPhotos($projectIdentity: ID!, $folder: String) {
    listProjectPhotos(projectIdentity: $projectIdentity, folder: $folder) {
      identity
      projectIdentity
      folder
      filename
      size
      mtime
      thumbnailUrl
    }
  }
`;

// ─── Task groups ─────────────────────────────────────────────────────────────

export const ADD_TASK_GROUP_WITH_TASKS_MUTATION = gql`
  mutation AddTaskGroupWithTasks($input: AddTaskGroupWithTasksInput!) {
    addTaskGroupWithTasks(input: $input) {
      group {
        identity
        properties { title project }
      }
      tasks {
        identity
        properties { title type assignee priority }
      }
    }
  }
`;

// ─── Journal ─────────────────────────────────────────────────────────────────

export const GET_JOURNAL_ENTRIES_QUERY = gql`
  query GetJournalEntries($username: String!, $tag: String, $from: String, $to: String, $includeArchived: Boolean, $limit: Int) {
    getJournalEntries(username: $username, tag: $tag, from: $from, to: $to, includeArchived: $includeArchived, limit: $limit) {
      identity
      properties {
        username
        body
        title
        mood
        tags
        source
        archived
        createdAt
        updatedAt
      }
    }
  }
`;

export const GET_REFLECTIONS_QUERY = gql`
  query GetReflections($username: String!, $linkedEntryId: ID, $limit: Int) {
    getReflections(username: $username, linkedEntryId: $linkedEntryId, limit: $limit) {
      identity
      properties {
        username
        text
        model
        mode
        createdAt
      }
    }
  }
`;

export const ADD_JOURNAL_ENTRY_MUTATION = gql`
  mutation AddJournalEntry($input: JournalEntryInput!) {
    addJournalEntry(input: $input) {
      identity
      properties {
        username
        body
        title
        mood
        tags
        source
        archived
        createdAt
        updatedAt
      }
    }
  }
`;

export const UPDATE_JOURNAL_ENTRY_MUTATION = gql`
  mutation UpdateJournalEntry($identity: ID!, $input: JournalEntryUpdateInput!) {
    updateJournalEntry(identity: $identity, input: $input) {
      identity
      properties {
        body
        title
        mood
        tags
        archived
        updatedAt
      }
    }
  }
`;

export const DELETE_JOURNAL_ENTRY_MUTATION = gql`
  mutation DeleteJournalEntry($identity: ID!) {
    deleteJournalEntry(identity: $identity)
  }
`;

export const ADD_REFLECTION_MUTATION = gql`
  mutation AddReflection($input: ReflectionInput!) {
    addReflection(input: $input) {
      identity
      properties {
        username
        text
        model
        mode
        createdAt
      }
    }
  }
`;

export const DELETE_REFLECTION_MUTATION = gql`
  mutation DeleteReflection($identity: ID!) {
    deleteReflection(identity: $identity)
  }
`;
